module.exports = __webpack_public_path__ + "static/media/may.e153262e.jpg";